// Shared client for the inbox-server (chat.parmegastore.com).
// Every request automatically carries the JWT from localStorage so the
// inbox-server can authenticate the caller. Same token the main API uses.

export const INBOX_URL = process.env.REACT_APP_INBOX_URL || 'https://chat.parmegastore.com';

function getAuthHeader() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// fetch wrapper: pass a path like '/api/conversations?page=1' and it will
// be prefixed with INBOX_URL and have the Authorization header injected.
export function inboxFetch(path, options = {}) {
  const url = path.startsWith('http') ? path : `${INBOX_URL}${path}`;
  const { headers = {}, ...rest } = options;
  return fetch(url, {
    ...rest,
    headers: { ...getAuthHeader(), ...headers }
  });
}

// Pass to socket.io-client `io(url, { auth: inboxSocketAuth(), ... })`
// so the inbox-server's io.use() middleware can verify the connection.
export function inboxSocketAuth() {
  return { token: localStorage.getItem('token') || '' };
}
